import React, { useContext } from 'react';
import AuthContext from '../context/AuthContext';
import { formatInstantDate } from '../utils/datetime';

const UserTable = ({ users, onEdit, onToggleActive, onDelete, loading }) => {
  const { timezone } = useContext(AuthContext);

  if (loading) return <div>Loading users...</div>;
  if (!users || users.length === 0) return <p>No users found</p>;

  return (
    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
      <thead>
        <tr style={{ backgroundColor: '#3D3D3D', color: 'white' }}>
          <th style={{ padding: '12px', textAlign: 'left' }}>Email</th>
          <th style={{ padding: '12px', textAlign: 'left' }}>Name</th>
          <th style={{ padding: '12px', textAlign: 'left' }}>Status</th>
          <th style={{ padding: '12px', textAlign: 'left' }}>Created</th>
          <th style={{ padding: '12px', textAlign: 'left' }}>Actions</th>
        </tr>
      </thead>
      <tbody>
        {users.map((user) => (
          <tr key={user.id} style={{ borderBottom: '1px solid #ddd', opacity: user.deleted ? 0.6 : 1 }}>
            <td style={{ padding: '12px' }}>{user.email}</td>
            <td style={{ padding: '12px' }}>{user.name}</td>
            <td style={{ padding: '12px' }}>
              <button
                onClick={() => onToggleActive(user.id, !user.is_active)}
                style={{
                  backgroundColor: user.is_active ? '#A0BD46' : '#ccc',
                  color: 'white',
                  border: 'none',
                  padding: '4px 8px',
                  borderRadius: '4px',
                  cursor: 'pointer'
                }}
              >
                {user.is_active ? '✓ Active' : '✗ Inactive'}
              </button>
            </td>
            <td style={{ padding: '12px', fontSize: '12px' }}>
              {formatInstantDate(user.created_at, timezone)}
            </td>
            <td style={{ padding: '12px' }}>
              {!user.deleted && (
                <>
                  <button
                    onClick={() => onEdit(user.id)}
                    style={{
                      backgroundColor: '#20BDE2',
                      color: 'white',
                      border: 'none',
                      padding: '4px 8px',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      marginRight: '5px'
                    }}
                  >
                    Edit
                  </button>
                  <button
                    onClick={() => onDelete(user.id)}
                    style={{
                      backgroundColor: '#F22B55',
                      color: 'white',
                      border: 'none',
                      padding: '4px 8px',
                      borderRadius: '4px',
                      cursor: 'pointer'
                    }}
                  >
                    Delete
                  </button>
                </>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default UserTable;
